import Axios from 'axios';
const followRedirects = require('follow-redirects');
followRedirects.maxBodyLength = 100 * 1024 * 1024; // 100 MB
Axios.defaults.maxContentLength = Infinity

export default {
	
	summary(filters) {

		let url = '/electronicDocuments/summary';
		return Axios.get(url, {
			params: filters
		})
	},

	queryElectronicDocuments(filters) {
		
		let url = '/electronicDocuments/queryElectronicDocuments';
		return Axios.get(url, {
			params: filters
		})
	},

	downloadExcel(userId, agencyId, aps, query) {
		const params = {
			idUsuario: userId,
			idAgencia: agencyId,
			aps:aps,
			query: query
		};
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")
		return Axios.get(
			"/electronicDocuments/downloadExcel", {
			responseType: 'arraybuffer',
			params: params
			}
		);
	},
	
	downloadPdf(userId, agencyId, aps, query) {
		const params = {
			idUsuario: userId,
			idAgencia: agencyId,
			aps:aps,
			query: query
		};
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("accessToken")
		return Axios.get(
			"/electronicDocuments/downloadPdf", {
			responseType: 'arraybuffer',
			params: params
			}
		);
	},

	getDocuments(referenceId) {
		
		let url = '/electronicDocuments/getDocuments';
		return Axios.get(url, {
			params: {
				referenceId: referenceId
			}
		})
	},

}